import * as React from "react";
const SvgFiRrHurricane = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hurricane_svg__a)">
      <path
        fill="#062147"
        d="M10.428 24H6a1 1 0 1 1 0-2 6.44 6.44 0 0 0 3.818-1.24 10.04 10.04 0 0 1-7.266-13.1A11.47 11.47 0 0 1 13.572 0H18a1 1 0 1 1 0 2 6.44 6.44 0 0 0-3.818 1.24 10.04 10.04 0 0 1 7.266 13.1A11.47 11.47 0 0 1 10.428 24m2.047-21.941A9.39 9.39 0 0 0 4.45 8.3a8.04 8.04 0 0 0 6.085 10.569 1.81 1.81 0 0 1 1.436 1.352 1.84 1.84 0 0 1-.446 1.725 9.39 9.39 0 0 0 8.026-6.246 8.04 8.04 0 0 0-6.085-10.565 1.81 1.81 0 0 1-1.437-1.352 1.84 1.84 0 0 1 .446-1.724M12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hurricane_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHurricane;
